import React from 'react';
import Layout from './Layout';
const MainLayout = ({ children }) => {
    return React.createElement(Layout, null, children);
};
export default MainLayout;
